import React from "react";
import ReactTooltip from "react-tooltip";

export const renderTooltipCell = ({
  tooltipId,
  valueTooltip,
  value,
  minWidth = 0,
  maxWidth,
  width = "100%",
  onClick,
  cursor = "pointer",
  className,
}) => (
  <div
    style={{
      flex: 1,
      minWidth,
      maxWidth,
      width,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      cursor: cursor,
    }}
    className={className}
    data-tip
    data-for={tooltipId}
    onClick={onClick}
  >
    <ReactTooltip id={tooltipId} delayShow={800}>
      <span>{valueTooltip || value}</span>
    </ReactTooltip>
    {value}
  </div>
);

export default renderTooltipCell;
